import React, { useEffect, useState } from "react";
import {
  collection,
  doc,
  documentId,
  getDoc,
  getDocs,
  query,
  where
} from "firebase/firestore";
import { db } from "../firebase";

const UsersContext = React.createContext();

const UsersProvider = ({ children }) => {
  const moment = require("moment");
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState(() => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : "";
  });
  const [userEmail, setUserEmail] = useState("");
  const [answersData, setAnswersData] = useState(() => {
    const answersData = localStorage.getItem("answersData");
    return answersData ? JSON.parse(answersData) : [];
  });
  const [readingTestData, setReadingTestData] = useState(() => {
    const readingSData = localStorage.getItem("readingSData");
    return readingSData ? JSON.parse(readingSData) : [];
  });

  const [readingSData, setReadingSData] = useState(() => {
    const readingSData = localStorage.getItem("readingSData");
    return readingSData ? JSON.parse(readingSData) : [];
  });
  const [readingSDataRes, setReadingSDataRes] = useState(() => {
    const readingSDataRes = localStorage.getItem("readingSDataRes");
    return readingSDataRes ? JSON.parse(readingSDataRes) : [];
  });
  const [readingChainData, setReadingChainData] = useState(() => {
    const readingChainData = localStorage.getItem("readingChainData");
    return readingChainData ? JSON.parse(readingChainData) : [];
  });
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState(() => {
    const questions = localStorage.getItem("questions");
    return questions ? JSON.parse(questions) : [];
  });
  const [resultFromOtherTest, setResultFromOtherTest] = useState([]);
  const [improvmentResults, setImprovmentResults] = useState([]);
  const [improvmentResultsTotal, setImprovmentResultsTotal] = useState(() => {
    const improvmentResultsTotal = localStorage.getItem(
      "improvmentResultsTotal"
    );
    return improvmentResultsTotal ? JSON.parse(improvmentResultsTotal) : [];
  });
  const [ansrDate, setAnsrDate] = useState([]);
  const [ansrDatesForChart, setAnsrDatesForChart] = useState([]);
  const [readingSDate, setReadingSDate] = useState([]);
  const [ansrResTotal, setAnsrResTotal] = useState([]);
  const [ansrResTotalChart, setAnsrResTotalChart] = useState([]);
  const [emailReportTexts, setEmailReportTexts] = useState({});
  const [checkStared] = useState(true);
  const [assignedUserIds, setAssignedUserIds] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [readingChainDataForChart, setReadingChainDataForChart] = useState([]);
  const [
    vTestImporvingResultsForChart,
    setVTestImporvingResultsForChart
  ] = useState([]);

  const questionToAdd = {
    question:
      "Ser du orden röra sig, hoppa, simma eller verkar de flyta på sidan när du läser eller utför närarbete?",
    answer: "NOTFROMDB",
    value: 1,
    maxScore: 4
  };

  useEffect(() => {
    const answersData = JSON.parse(localStorage.getItem("answersData"));
    const readingSData = JSON.parse(localStorage.getItem("readingSData"));
    const readingTestData = JSON.parse(localStorage.getItem("readingTestData"));
    const questions = JSON.parse(localStorage.getItem("questions"));
    const user = JSON.parse(localStorage.getItem("user"));
    const improvmentResultsTotal = JSON.parse(
      localStorage.getItem("improvmentResultsTotal")
    );

    if (answersData) {
      setAnswersData(answersData);
    }
    if (readingSData) {
      setReadingSData(readingSData);
    }
    if (readingTestData) {
      setReadingTestData(readingTestData);
    }
    if (questions) {
      setQuestions(questions);
    }
    if (user) {
      setUser(user);
    }

    if (readingChainData) {
      setReadingChainData(readingChainData);
    }

    if (readingSDataRes) {
      setReadingSDataRes(readingSDataRes);
    }
    if (improvmentResultsTotal) {
      setImprovmentResultsTotal(improvmentResultsTotal);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("answersData", JSON.stringify(answersData));
  }, [answersData]);

  useEffect(() => {
    localStorage.setItem("readingSData", JSON.stringify(readingSData));
  }, [readingSData]);
  useEffect(() => {
    localStorage.setItem("readingTestData", JSON.stringify(readingTestData));
  }, [readingTestData]);

  useEffect(() => {
    localStorage.setItem("questions", JSON.stringify(questions));
  }, [questions]);

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(user));
  }, [user]);

  useEffect(() => {
    localStorage.setItem("readingSDataRes", JSON.stringify(readingSDataRes));
  }, [readingSDataRes]);

  useEffect(() => {
    localStorage.setItem("readingChainData", JSON.stringify(readingChainData));
  }, [readingChainData]);

  useEffect(() => {
    localStorage.setItem(
      "improvmentResultsTotal",
      JSON.stringify(improvmentResultsTotal)
    );
  }, [improvmentResultsTotal]);

  const getSubAdminData = async id => {
    setAssignedUserIds([]);
    const docRef = doc(db, "SubAdminData", id);
    const adminSnapData = await getDoc(docRef);
    if (adminSnapData.exists()) {
      setAssignedUserIds(
        adminSnapData.data().AssignedUsers
          ? adminSnapData.data().AssignedUsers
          : []
      );
    }
  };

  function toDateTime(secs) {
    var t = new Date(1970, 0, 1); // Epoch
    t.setSeconds(secs);
    return t;
  }

  const getUser = async Email => {
    let queryUsers = query(
      collection(db, `UserData`),
      where("Email", "==", `${Email}`)
    );
    const usersDocs = await getDocs(queryUsers);
    let uDocs = usersDocs.docs;

    const dataFromSql = await getUserAnswersFromSQL(uDocs[0].id);
    
    uDocs.map(doc => {
      setUser(prevData => [...prevData, doc.data()]);
      return (
        doc.data().UserAnswers &&
          getAnswers(doc.data().UserAnswers, "UserAnswers", dataFromSql),
        doc.data().ReadingSpeed &&
          getReadingSpeed(doc.data().ReadingSpeed, "ReadingSpeed")
      );
    });
  };

  const getUsersInfo = async () => {
    console.log("called getUsersInfo");
    let queryUsers;
    if (checkStared === true) {
      queryUsers = query(
        collection(db, `UserData`),
        where("Starred", "==", true)
      );
    } else {
      console.log("else");
      queryUsers = query(collection(db, `UserData`));
    }
    const usersDocs = await getDocs(queryUsers);
    let usrsDocs = usersDocs.docs;

    setUsers([]);
    usrsDocs.map(doc => {
      return setUsers(prevData => [...prevData, doc.data()]);
    });
  };

  // const getTestQuestions = async () => {
  //   const queryQuestions = query(collection(db, `TestQuestions`));
  //   const questionsDocs = await getDocs(queryQuestions);
  //   let quesDocs = questionsDocs.docs;
  //   quesDocs.map(doc => {
  //     setQuestions(doc.data().Questions);
  //   });
  // };

  const getTestQuestions = async () => {
    const postData = {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };
    const res = await fetch(
      `https://europe-central2-imvi-read.cloudfunctions.net/fetch-vergence-questions`,
      postData
    );
    const response = await res.json();
    setQuestions(response);
  };

  const getUserData = async (ids, collectionName) => {
    let dataIds = [];
    if (ids.length > 0) {
      ids.forEach(item => {
        dataIds.push(item.id);
      });
    }
    if (dataIds.length > 0) {
      const dataRef = collection(db, collectionName);

      // Splitting ids into chunks of 30
      let chunks = [];
      while (dataIds.length) {
        chunks.push(dataIds.splice(0, 30));
      }

      // Variable to accumulate data from all chunks
      let allData = [];

      // Fetching data for each chunk
      for (let chunk of chunks) {
        const dataDocSnap = query(dataRef, where(documentId(), "in", chunk));
        let dataDocs = await getDocs(dataDocSnap);
        let data = dataDocs.docs;
        allData = [...allData, ...data];
      }

      return allData;
    }
    return [];
  };

  function transformApiDataToTableData(apiData) {
    if (apiData.sessions) {
      return apiData.sessions.map((session, index) => {
        if (session.questions.length < 15)
          session.questions.splice(7, 0, questionToAdd);
        let totalValue = session.questions.reduce((acc, q) => acc + q.value, 0);
        const dateObject = new Date(session.created_at);
        const seconds = dateObject.getTime() / 1000;
        const formattedDate = seconds;

        return {
          id: index + 1,
          total: totalValue,
          answeredOn: formattedDate,
          details: session.questions
        };
      });
    }
  }

  const getUserAnswersFromSQL = async id => {
    let tableData = [];
    const fetchAnswers = {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };
    const answersResult = await fetch(
      `https://europe-central2-imvi-read.cloudfunctions.net/get-vergence-results?uuid=${id}`,
      fetchAnswers
    );
    const response = await answersResult.json();
    if (response) {
      setLoading(false);
      tableData = transformApiDataToTableData(response);
    }
    return tableData;
  };

  const getAnswers = async (ids, collectionName, arrDataFromSql) => {
    let reformAnswersArray = [];
    let dataFromFirestore = await getUserData(ids, collectionName);
    if (dataFromFirestore) {
      dataFromFirestore.sort((a, b) => {
        return (
          new Date(a.data().DateOfAnswering.toDate()) -
          new Date(b.data().DateOfAnswering.toDate())
        );
      });
      dataFromFirestore.forEach(answerDoc => {
        const modifiedDetails = answerDoc.data().Answers.map(item => {
          return {
            question: item.Question,
            value: item.Answer
          };
        });

        const reformAnswers = {
          id: answerDoc.id,
          answeredOn: answerDoc.data().DateOfAnswering.seconds,
          details: modifiedDetails,
          total: answerDoc.data().Total
        };
        reformAnswersArray.push(reformAnswers);
      });
       setAnswersData(prevData => [...prevData, ...reformAnswersArray]);
      if (arrDataFromSql && arrDataFromSql.length > 0) {
        setAnswersData(arrDataFromSql);
      }
    }
  };

  const getReadingSpeed = async (ids, collectionName) => {
    let data = await getUserData(ids, collectionName);
    if (data) {
      data.sort((a, b) => {
        return (
          new Date(a.data().RecordedAtTime.toDate()) -
          new Date(b.data().RecordedAtTime.toDate())
        );
      });
      data.forEach(readingDoc => {
        setReadingSData(prevData => [
          ...prevData,
          { id: readingDoc.id, ...readingDoc.data() }
        ]);
        setReadingTestData(prevData => [
          ...prevData,
          { id: readingDoc.id, ...readingDoc.data() }
        ]);
      });
    }
  };

  const getText = async () => {
    const querySnapshot = await getDocs(collection(db, "EmailResultText"));
    let allTexts = {};
    
    querySnapshot.forEach(doc => {
      // Store each document's data with its ID as the key
      allTexts[doc.id] = doc.data();
    });
    
    setEmailReportTexts(allTexts);
    setLoading(false);
  };

  const userResults = data => {
    let ansrDate = [];
    let ansrItems = [];
    let sumTotal = [];
    let cloneTotalArrImprove = [];
    let ansrItemsWithoutfirstTest = [];
    if (data.length > 0) {
      data.forEach(items => {
        ansrItems.push(items.details);
        ansrDate.push(toDateTime(items.answeredOn));
        sumTotal.push(items.total);
      });
      ansrDate.shift();
      setAnsrDate(ansrDate);

      if (ansrItems.length === 1) {
        return null;
      }

      if (ansrItems.length > 1) {
        ansrItemsWithoutfirstTest = [...ansrItems];
        let resultArr = ansrItemsWithoutfirstTest.shift();
        let totalArr = sumTotal.shift();
        let cloneTotalArr = [];
        ansrItemsWithoutfirstTest.forEach(arr => {
          let clonedDevResArr = [];
          let clonedImproveResArr = [];
          if (arr.length === 15) {
            if (resultArr.length < 15) resultArr.splice(7, 0, questionToAdd);
            for (let x = 0; x <= arr.length - 1; x++) {
              let calculateImprove = Math.round(
                (1 - arr[x].value / resultArr[x].value) * 100
              );
              if (
                calculateImprove === -Infinity ||
                calculateImprove === Infinity ||
                isNaN(calculateImprove)
              ) {
                calculateImprove = 0;
              }
              clonedImproveResArr.push(`${calculateImprove}%`);
            }

            for (let x = 0; x <= arr.length - 1; x++) {
              clonedDevResArr.push(arr[x].value - resultArr[x].value);
            }
            setResultFromOtherTest(prevState => [
              ...prevState,
              clonedDevResArr
            ]);
            setImprovmentResults(prevState => [
              ...prevState,
              clonedImproveResArr
            ]);
          }
        });
        for (let x = 0; x <= sumTotal.length - 1; x++) {
          cloneTotalArr.push(sumTotal[x] - totalArr);
        }

        for (let x = 0; x <= sumTotal.length - 1; x++) {
          cloneTotalArrImprove.push(
            `${Math.round((1 - sumTotal[x] / totalArr) * 100)}%`
          );
        }

        setAnsrResTotal(cloneTotalArr);
        setImprovmentResultsTotal(cloneTotalArrImprove);
      }
    }
  };

  const usersVergenceTestResultsForCharts = (data, userId) => {
    let ansrDate = [];
    let ansrItems = [];
    let sumTotal = [];
    let cloneTotalArrImprove = [];
    let ansrItemsWithoutfirstTest = [];
    if (data.length > 0) {
      data.forEach(items => {
        const formatedDate = toDateTime(items.answeredOn);
        ansrItems.push(items.details);
        ansrDate.push(moment(formatedDate).format("DD-MMM-YY"));
        sumTotal.push(items.total);
      });
      //  ansrDate.shift();
      setAnsrDatesForChart(prev =>
        [...prev, { userId, dates: ansrDate, total: sumTotal }].filter(
          (test, index, self) =>
            index === self.findIndex(t => t.userId === test.userId)
        )
      );

      if (ansrItems.length === 1) {
        return null;
      }

      if (ansrItems.length > 1) {
        ansrItemsWithoutfirstTest = [...ansrItems];
        let resultArr = ansrItemsWithoutfirstTest.shift();
        let totalArr = [...sumTotal].shift();
        let cloneTotalArr = [];
        ansrItemsWithoutfirstTest.forEach(arr => {
          let clonedDevResArr = [];
          let clonedImproveResArr = [];
          if (arr.length === 15) {
            if (resultArr.length < 15) resultArr.splice(7, 0, questionToAdd);
            for (let x = 0; x <= arr.length - 1; x++) {
              let calculateImprove = Math.round(
                (1 - arr[x].value / resultArr[x].value) * 100
              );
              if (
                calculateImprove === -Infinity ||
                calculateImprove === Infinity ||
                isNaN(calculateImprove)
              ) {
                calculateImprove = 0;
              }
              clonedImproveResArr.push(`${calculateImprove}%`);
            }

            for (let x = 0; x <= arr.length - 1; x++) {
              clonedDevResArr.push(arr[x].value - resultArr[x].value);
            }
            setResultFromOtherTest(prevState => [
              ...prevState,
              clonedDevResArr
            ]);
            setImprovmentResults(prevState => [
              ...prevState,
              clonedImproveResArr
            ]);
          }
        });
        for (let x = 0; x <= sumTotal.length - 1; x++) {
          cloneTotalArr.push(sumTotal[x] - totalArr);
        }

        for (let x = 0; x <= sumTotal.length - 1; x++) {
          cloneTotalArrImprove.push(
            Math.round((1 - sumTotal[x] / totalArr) * 100)
          );
        }

        setAnsrResTotalChart(prev =>
          [...prev, { userId, totalAnswerValues: cloneTotalArr }].filter(
            (test, index, self) =>
              index === self.findIndex(t => t.userId === test.userId)
          )
        );
      }
      setVTestImporvingResultsForChart(prev =>
        [...prev, { userId, data: cloneTotalArrImprove }].filter(
          (test, index, self) =>
            index === self.findIndex(t => t.userId === test.userId)
        )
      );
    }
  };

  const getReadingSpeedDate = data => {
    let rsDate = [];
    if (data) {
      if (data.length > 0) {
        data.forEach(items => {
          rsDate.push(toDateTime(items.RecordedAtTime.seconds));
        });

        rsDate.shift();
        return rsDate;
      }
    } else {
      if (readingSData.length > 0) {
        readingSData.forEach(items => {
          rsDate.push(toDateTime(items.RecordedAtTime.seconds));
        });

        rsDate.shift();
        setReadingSDate(rsDate);
      }
    }
  };

  const calculatingReadingImprovment = () => {
    if (readingSData.length > 0) {
      let readingResults_1 = [];
      let readingResults_2 = [];
      let readingResults_3 = [];

      readingSData.forEach((rs, i) => {
        readingResults_1.push(rs.ReadingSpeed_1);
        readingResults_2.push(rs.ReadingSpeed_2);
        readingResults_3.push(rs.ReadingSpeed_3);
      });

      let imp_1 = [];

      let readingSpeedRes = [
        readingResults_1,
        readingResults_2,
        readingResults_3
      ];

      let fItem;

      readingSpeedRes.forEach((arr, idx) => {
        fItem = arr[0];

        for (let i = 1; i < arr.length; i++) {
          imp_1.push(Math.round((arr[i] / fItem - 1) * 100));
        }
      });

      let num = imp_1.length / 3;
      let newArr = listToMatrix(imp_1, num);
      setReadingSDataRes(newArr);
    }
  };

  const calculatingTestReadingImprovment = data => {
    if (data.length > 0) {
      let readingResults_1 = [];
      let readingResults_2 = [];
      let readingResults_3 = [];

      data.forEach((rs, i) => {
        readingResults_1.push(rs.letters_score);
        readingResults_2.push(rs.words_score);
        readingResults_3.push(rs.sentences_score);
      });

      let imp_1 = [];

      let readingSpeedRes = [
        readingResults_1,
        readingResults_2,
        readingResults_3
      ];

      let fItem;

      readingSpeedRes.forEach((arr, idx) => {
        fItem = arr[0];

        for (let i = 1; i < arr.length; i++) {
          imp_1.push(Math.round((arr[i] / fItem - 1) * 100));
        }
      });

      let num = imp_1.length / 3;
      let newArr = listToMatrix(imp_1, num);
      setReadingChainData(newArr);
    }
  };

  const calculatingTestReadingImprovmentForCharts = (userId, data) => {
    if (data.length > 0) {
      let readingResults_1 = [];
      let readingResults_2 = [];
      let readingResults_3 = [];

      data.forEach((rs, i) => {
        readingResults_1.push(rs.letters_score);
        readingResults_2.push(rs.words_score);
        readingResults_3.push(rs.sentences_score);
      });

      let imp_1 = [];

      let readingSpeedRes = [
        readingResults_1,
        readingResults_2,
        readingResults_3
      ];

      let fItem;

      readingSpeedRes.forEach((arr, idx) => {
        fItem = arr[0];

        for (let i = 1; i < arr.length; i++) {
          imp_1.push(Math.round((arr[i] / fItem - 1) * 100));
        }
      });

      let num = imp_1.length / 3;
      let newArr = listToMatrix(imp_1, num);
      newArr.forEach(subarray => {
        subarray.unshift(0);
      });
      setReadingChainDataForChart([
        ...readingChainDataForChart,
        { userId, score: newArr }
      ]);
    }
  };

  function listToMatrix(list, elementsPerSubArray) {
    var matrix = [],
      i,
      k;

    for (i = 0, k = -1; i < list.length; i++) {
      if (i % elementsPerSubArray === 0) {
        k++;
        matrix[k] = [];
      }

      matrix[k].push(list[i]);
    }
    return matrix;
  }

  return (
    <UsersContext.Provider
      value={{
        userEmail: userEmail,
        setUserEmail: userEmail => setUserEmail(userEmail),
        calculatingTestReadingImprovment,
        calculatingTestReadingImprovmentForCharts,
        answersData,
        setAnswersData,
        users: users,
        setUsers: users => setUsers(users),
        user: user,
        getUser,
        getUsersInfo,
        setUser,
        getTestQuestions,
        questions,
        userResults,
        ansrDate,
        ansrResTotal,
        resultFromOtherTest,
        setResultFromOtherTest,
        improvmentResultsTotal,
        setImprovmentResultsTotal,
        improvmentResults,
        setImprovmentResults,
        readingSDate,
        setReadingSDate,
        readingSData,
        setReadingSData,
        readingTestData,
        setReadingTestData,
        readingSDataRes,
        setReadingSDataRes,
        readingChainData,
        setReadingChainData,
        getReadingSpeedDate,
        calculatingReadingImprovment,
        getText,
        emailReportTexts,
        loading,
        setLoading,
        checkStared,
        assignedUserIds,
        getSubAdminData,
        assignedUsers,
        setAssignedUsers,
        readingChainDataForChart,
        setReadingChainDataForChart,
        getUserAnswersFromSQL,
        getAnswers,
        vTestImporvingResultsForChart,
        setVTestImporvingResultsForChart,
        usersVergenceTestResultsForCharts,
        ansrDatesForChart,
        ansrResTotalChart,
        setAssignedUserIds
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};

export { UsersContext, UsersProvider };
